





















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import echarts from 'echarts/lib/echarts';

@Component
export default class DependencySankey extends Vue {
  @Prop() private data: any;
  @Getter('durationTime') private durationTime: any;
  @Action('rocketTopo/GET_INSTANCE_DEPENDENCY_METRICS') private GET_INSTANCE_DEPENDENCY_METRICS: any;

  get optionConfigs() {
    return {
      series: {
        type: 'sankey',
        left: 40,
        top: 20,
        right: 300,
        bottom: 40,
        focusNodeAdjacency: 'allEdges',
        data: this.data.nodes,
        links: this.data.calls,
        label: {
          color: '#fff',
          formatter: ((param: any) => param.data.name),
        },
        color: [
            '#3fe1da',
            '#6be6c1',
            '#3fcfdc',
            '#626c91',
            '#3fbcde',
            '#a0a7e6',
            '#3fa9e1',
            '#96dee8',
            '#bf99f8',
          ],
        itemStyle: {
          normal: {
            borderWidth: 0,
          },
        },
        lineStyle: {
          normal: {
            color: 'source',
            opacity: 0.12,
          },
        },
      },
    };
  }

  private clickLinks(params: any) {
    if (params.dataType === 'edge' && params.data) {
      this.GET_INSTANCE_DEPENDENCY_METRICS({
        ...params.data,
        durationTime: this.durationTime,
        mode: params.data.detectPoints[0],
      });
    }
  }
}
